import { render, staticRenderFns } from "./monitoring-numbers-tasks.vue?vue&type=template&id=a65b9872&"
import script from "./monitoring-numbers-tasks.vue?vue&type=script&lang=js&"
export * from "./monitoring-numbers-tasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports